// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f3f4f6;
}

.success-box {
    text-align: center;
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    width: 350px;
}

.success-icon {
    font-size: 50px;
    color: #006E74;
    margin-bottom: 10px;
}

.success-message {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 15px;
}

.login-button {
    width: 100%;
    background-color: #006E74 !important;
    border: none;
}

.login-button:hover {
    background-color: #005960 !important;
}
`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/trackon/src/components/PasswordChanged/PasswordChanged.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":[".success-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background-color: #f3f4f6;\n}\n\n.success-box {\n    text-align: center;\n    background: white;\n    padding: 30px;\n    border-radius: 8px;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    width: 350px;\n}\n\n.success-icon {\n    font-size: 50px;\n    color: #006E74;\n    margin-bottom: 10px;\n}\n\n.success-message {\n    font-size: 1.2rem;\n    font-weight: bold;\n    margin-bottom: 15px;\n}\n\n.login-button {\n    width: 100%;\n    background-color: #006E74 !important;\n    border: none;\n}\n\n.login-button:hover {\n    background-color: #005960 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
